<div class="content-wrapper-parent">
  <div class="content-wrapper">
    <div class="marketplace-container">
      <!-- Loading State -->
      <div *ngIf="state === 'loading' || state === 'activating'" class="marketplace-panel">
        <div class="marketplace-panel-content text-center">
          <mat-spinner diameter="60" class="mx-auto mb-24"></mat-spinner>
          <h2 class="mb-16">{{ loadingMessage }}</h2>
          <p class="text-secondary">Please wait while we process your subscription...</p>
        </div>
      </div>

      <!-- No Token Error -->
      <div *ngIf="state === 'no-token'" class="marketplace-panel">
        <div class="marketplace-panel-content">
      <div class="flex align-center gap-16 mb-24">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h2>Invalid Marketplace Link</h2>
      </div>
      <p class="mb-24">{{ errorMessage }}</p>
      <p class="text-secondary mb-24">
        If you received this link from Azure Marketplace, please try clicking the link again. 
        If the problem persists, please contact our support team.
      </p>
        </div>
      </div>

      <!-- Subscription Resolved - Needs Authentication -->
      <div *ngIf="state === 'resolved' && !isAuthenticated && subscriptionDetails" class="marketplace-panel">
        <div class="marketplace-panel-content">
      <div class="flex align-center gap-16 mb-24">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h2>Subscription Found</h2>
      </div>
      
      <div class="subscription-details mb-32">
        <h3 class="mb-16">Subscription Details</h3>
        <div class="detail-row">
          <span class="label">Subscription Name:</span>
          <span class="value">{{ subscriptionDetails.subscriptionName }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Plan:</span>
          <span class="value">{{ subscriptionDetails.planId }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Quantity:</span>
          <span class="value">{{ subscriptionDetails.quantity }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Purchaser Email:</span>
          <span class="value">{{ subscriptionDetails.purchaserEmail }}</span>
        </div>
      </div>

      <div class="info-box mb-24">
        <mat-icon>info</mat-icon>
        <p>To complete your subscription activation, you need to sign in to your account or create a new one.</p>
      </div>

          <div class="flex gap-16">
            <button mat-raised-button color="primary" (click)="goToLogin()">
              <mat-icon>login</mat-icon>
              Sign In
            </button>
            <button mat-raised-button (click)="goToRegister()">
              <mat-icon>person_add</mat-icon>
              Sign Up
            </button>
          </div>
        </div>
      </div>

      <!-- Error State -->
      <div *ngIf="state === 'error'" class="marketplace-panel">
        <div class="marketplace-panel-content">
      <div class="flex align-center gap-16 mb-24">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h2>Activation Error</h2>
      </div>
      
      <p class="mb-24">{{ errorMessage }}</p>
      
      <div class="info-box mb-24">
        <mat-icon class="info-icon">info</mat-icon>
        <div class="info-content">
          <p class="font-semibold mb-8">What happened?</p>
          <p class="mb-8">We encountered an issue while processing your subscription. This could be due to:</p>
          <ul>
            <li>An expired or invalid subscription token</li>
            <li>A temporary connection issue</li>
            <li>The subscription has already been activated</li>
          </ul>
        </div>
      </div>

          <div class="flex gap-16">
            <button mat-raised-button color="primary" (click)="retryActivation()">
              <mat-icon>refresh</mat-icon>
              Retry Activation
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
